<section class="mb-1">
  <app-toolbar [class.is-hidden]="building()">
    <div class="left search">
      <app-search-input [resultCount]="filteredCount()" [searchText]="filteredText()" (onSearchChanged)="searchChanged($event)" tooltipText="Search buildings, org, license" />
    </div>
    <div class="right">
      <app-button size="small" icon="mdi mdi-rotate-3d-variant" (click)="billableClick()" [label]="isBillable ? 'Billable buildings' : 'Not Billable buildings'" />
    </div>
  </app-toolbar>
</section>

<section [class.is-hidden]="building()">
  @if (dataTableList()) {
    <app-data-table [dataTable]="dataTableList()" dataTableKey="org:billing:buildings:list" (onRowClick)="listItemClicked($event)" />
  }

  <app-theme-page-section>
    @if (list()) {
      <ul>
        <li>
          {{ list().length }} buildings
          @if (filteredText()) {
            , {{ filteredBuildingList()?.length }} filtered
          }
          .
        </li>
      </ul>
    }
  </app-theme-page-section>
</section>

@if (building()) {
  <section>
    <app-theme-page-container [label]="building().title" [canNavigateBack]="true" (onBack)="building.set(null)" theme="light">
      <app-billing-buildings-home [building]="building()"></app-billing-buildings-home>
      <!--		<app-building-license-home [building]="building"></app-building-license-home> -->
    </app-theme-page-container>
  </section>
}
